import { useMemo } from 'react';

import { type D3FormatString, formatValue } from './use-format-value';

const formatNumber = (value?: string | number, d3Format: D3FormatString = ',') =>
    formatValue(value, d3Format, 'number');

const useFormatNumber = (value?: string | number, d3Format: D3FormatString = ',') => {
    return useMemo(() => {
        if (value === undefined || (typeof value !== 'string' && typeof value !== 'number')) return value;
        return formatNumber(value, d3Format);
    }, [d3Format, value]);
};

export { formatNumber, useFormatNumber };
